import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthFacade } from '../../domains/app/auth/auth.facade';

/**
 * Endpoints whose 401 must NOT be read as "this person's session has expired".
 *
 * TT-175: the app-switcher call is kicked off from the root component's field
 * initialiser, so it can leave before authentication has finished and come back
 * 401. TradeTapAppsService already shrugs that off and falls back to a default
 * list, so nothing is broken by it. But this interceptor saw the 401 first and
 * declared the whole session dead, which put a modal "Session Expired" dialog
 * in front of people whose session was perfectly healthy. Paul hit it hard
 * enough to be locked out of the app for two hours.
 *
 * The rule: a request that carries its own failure handling cannot be allowed
 * to sign everybody out.
 */
const NON_SESSION_CRITICAL = [/\/users\/me\/apps$/];

@Injectable()
export class AuthSessionInterceptor implements HttpInterceptor {
  constructor(private auth: AuthFacade) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const optional = NON_SESSION_CRITICAL.some(rx => rx.test((req.url || '').split('?')[0]));
    return next.handle(req).pipe(
      tap({
        error: error =>
          !optional && error instanceof HttpErrorResponse && error.status === 401 && this.auth.authSessionExpired(),
      }),
    );
  }
}
